<div class="modal-header"><h2 class="modal-title">Enter Job Info</h2></div>
<div class="modal-body">
    <div class="flex-fill d-flex flex-column">
        <div class="card">
            <div class="card-body">
                <dx-form *ngIf="job" [formData]="job" labelLocation="top" validationGroup="mainValidationGroup">
                    <dxi-item itemType="group" [colCount]="4">
                        <dxi-item dataField="created" editorType="dxDateBox" [disabled]="true"></dxi-item>
                        <dxi-item dataField="jobNumber" [editorOptions]="{ disabled: false }"></dxi-item>
                        <dxi-item dataField="isQuotedJob" editorType="dxCheckBox" [editorOptions]="{ onValueChanged: allDaySelected }"></dxi-item>
                        <dxi-item itemType="empty"></dxi-item>

                        <dxi-item [label]="{ text: 'Customer' }" [colSpan]="2">
                            <div *dxTemplate>
                                <dx-autocomplete [(value)]="job.customerName" [dataSource]="customers" (onSelectionChanged)="customerSelected($event)" [readOnly]="readOnly">
                                </dx-autocomplete>
                            </div>
                            <dxi-validation-rule type="required" message="Customer Required"> </dxi-validation-rule>
                        </dxi-item>
                        <dxi-item dataField="highPriority" editorType="dxCheckBox" [editorOptions]="{}"></dxi-item>
                        <dxi-item itemType="empty"></dxi-item>

                        <dxi-item dataField="contactName" [colSpan]="2"></dxi-item>
                        <dxi-item dataField="jobTypeId" [label]="{text: 'Job Type'}" editorType="dxSelectBox" [editorOptions]="{items: jobTypes, valueExpr: 'id', displayExpr: 'name'}" [colSpan]="2"></dxi-item>

                        <dxi-item dataField="description" [editorOptions]="{ readOnly: readOnly }" [colSpan]="4">
                            <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                        </dxi-item>

                        <dxi-item dataField="cellPhone" [label]="{ text: 'Phone' }" [colSpan]="2"></dxi-item>
                        <dxi-item dataField="keyCode" [editorOptions]="{ readOnly: readOnly }"></dxi-item>
                        <dxi-item itemType="empty"></dxi-item>

                        <dxi-item dataField="email" [editorOptions]="{ readOnly: readOnly }" [colSpan]="2">
                            <dxi-validation-rule *ngIf="!job.noEmailProvided" type="required" message="Required"> </dxi-validation-rule>
                        </dxi-item>
                        <dxi-item dataField="noEmailProvided" editorType="dxCheckBox" [editorOptions]="{ onValueChanged: allDaySelected }"></dxi-item>
                        <dxi-item itemType="empty"></dxi-item>

                        <dxi-item dataField="isBillingAddress" editorType="dxCheckBox" [editorOptions]="{ onValueChanged: billingSame }"></dxi-item>
                        <dxi-item itemType="empty"></dxi-item>
                        <dxi-item itemType="empty"></dxi-item>
                        <dxi-item itemType="empty"></dxi-item>

                        <dxi-item itemType="group" caption="Job Address" [colCount]="1" [colSpan]="2">
                            <dxi-item dataField="jobAddress1" [label]="{ text: 'Address 1' }" [colSpan]="3"></dxi-item>
                            <dxi-item dataField="jobAddress2" [label]="{ text: 'Address 2' }" [colSpan]="3"></dxi-item>
                            <dxi-item itemType="group" [colCount]="3" [colSpan]="3">
                                <dxi-item dataField="jobCity" [label]="{ text: 'City' }" [colSpan]="1"></dxi-item>
                                <dxi-item dataField="jobState" [label]="{ text: 'State' }" [colSpan]="1"></dxi-item>
                                <dxi-item dataField="jobZip" [label]="{ text: 'Zip Code' }" [colSpan]="1"></dxi-item>
                            </dxi-item>
                        </dxi-item>
                        <dxi-item itemType="group" caption="Billing Address" [disabled]="job.isBillingAddress" [colCount]="1" [colSpan]="2">
                            <dxi-item dataField="billingAddress1" [label]="{ text: 'Address 1' }" [colSpan]="3">
                                <dxi-validation-rule *ngIf="!job.isBillingAddress" type="required" message="Required"> </dxi-validation-rule>
                            </dxi-item>
                            <dxi-item dataField="billingAddress2" [label]="{ text: 'Address 2' }" [colSpan]="3"></dxi-item>
                            <dxi-item itemType="group" [colCount]="3" [colSpan]="3">
                                <dxi-item dataField="billingCity" [label]="{ text: 'City' }" [colSpan]="1"></dxi-item>
                                <dxi-item dataField="billingState" [label]="{ text: 'State' }" [colSpan]="1"></dxi-item>
                                <dxi-item dataField="billingZip" [label]="{ text: 'Zip Code' }" [colSpan]="1"></dxi-item>
                            </dxi-item>
                        </dxi-item>

                        <dxi-item [label]="{ text: 'Notes' }" [colSpan]="4">
                            <div *dxTemplate><dx-text-area [(value)]="job.note" [height]="100" [readOnly]="readOnly"></dx-text-area></div>
                        </dxi-item>
                        <dxi-item itemType="empty"></dxi-item>
                    </dxi-item>

                    <!-- <dxi-item dataField="quantity" [label]="{ text: 'Qty (bushels)' }">
                        <dxi-validation-rule type="required" message="Quantity Required"> </dxi-validation-rule>
                        <dxi-validation-rule type="numeric" message="Needs to be a number"> </dxi-validation-rule>
                        <dxi-validation-rule type="range" min="1" message="Cannot be less than 1"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="bushelPrice" [label]="{ text: 'Price' }" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 } }">
                        <dxi-validation-rule type="required" message="Price Required"> </dxi-validation-rule>
                        <dxi-validation-rule type="numeric" message="Needs to be a number"> </dxi-validation-rule>
                        <dxi-validation-rule type="range" min="0.01" message="Cannot be less than 0.01"> </dxi-validation-rule>
                    </dxi-item> -->
                </dx-form>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()" [hidden]="readOnly">Save</button>
    <button type="button" class="btn btn-default" (click)="cancel()">{{ readOnly ? 'Close' : 'Cancel' }}</button>
</div>
